import { type AnalyticsCaptureParams, type AnalyticsReporter, cookieConsentGiven } from '@fuuze/shared';
import posthog from 'posthog-js';

export class PosthogReporter implements AnalyticsReporter {
  constructor() {
    if (import.meta.env.VITE_IS_LOCAL) return;

    posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
      api_host: 'https://t.fuuze.app',
      defaults: '2026-01-30',
      persistence: cookieConsentGiven() === 'yes' ? 'localStorage+cookie' : 'memory',
      capture_pageview: 'history_change',
      enable_heatmaps: true,
      capture_pageleave: true,
      capture_dead_clicks: true,
      disable_session_recording: true,
      rageclick: true,
    });
  }
  capture(params: AnalyticsCaptureParams): void {
    throw new Error('Method not implemented.');
  }
  close(): Promise<void> {
    throw new Error('Method not implemented.');
  }

  identifyUser(params: { id: string; pseudo?: string }) {
    const { id, pseudo } = params;
    posthog.identify(id, { pseudo });
  }

  reset() {
    posthog.reset();
  }
}
